import { type ReactNode } from 'react';
import { cn } from '@/utils/cn';
import { FADE } from './sidebar-styles';
import type { NavItem } from './sidebar-link';

export function SidebarLabel({
  item,
  collapsed,
}: {
  item: NavItem;
  collapsed: boolean;
}): ReactNode {
  return (
    <>
      <span className="shrink-0">{item.icon}</span>
      <span className={cn(FADE, collapsed ? 'opacity-0' : 'opacity-100')}>
        {item.label}
      </span>
    </>
  );
}
